module.exports = __webpack_public_path__ + "img/house.d1244ae9.svg";